@if (showComponent && !isMobile) {
  <div class="scroll-component">
    <div class=" topper">
      <div class=" kb-border">
        <cx-page-slot position="SiteLogo"></cx-page-slot>
        <div class="bottom-lower-header ">
          <cx-page-slot position="NavigationBar"></cx-page-slot>
        </div>
        <div class="upper-icons">
          <button (click)="showSearch = !showSearch" class="sticky-serach-button" type="button"
            mapp_data="icon | search">
            <img src="/icons/search-kb.svg" alt="Search">
          </button>
          @if (isLoggedIn) {
            <cx-page-slot position="MiniCart"></cx-page-slot>
          }
        </div>
      </div>
    </div>
    <div class="scrollable-searchtop">
      @if (showSearch) {
        <div class="scrollable-search-bar">
          <cx-page-slot position="SearchBox"></cx-page-slot>
          <img src="/icons/close_blue.svg" (click)="showSearch = !showSearch"
            style="width: 12px; margin-left: 20px;" class="close-sticky-search" alt="Search-bar">
          </div>
        }
      </div>
    </div>
  }